import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/styles';
import { useStyles } from './styles';

const Props = {
  element: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  options: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

const DefaultProps = {
  options: {},
};

export default function StripeElement({ element: Element, error, options, onChange }) {
  const theme = useTheme();
  const classes = useStyles();
  const [styleOptions, setStyleOptions] = useState({
    classes: { base: classes.root },
    style: {
      base: {
        fontSize: `${theme.typography.htmlFontSize}px`,
        color: theme.palette.text.primary,
      },
      invalid: { color: theme.palette.text.primary },
    },
  });

  function getStyleOptions() {
    if (error) {
      return {
        ...styleOptions,
        classes: { base: `${classes.root} ${classes.error}` },
      };
    }

    return styleOptions;
  }

  function handleFocus() {
    setStyleOptions({
      ...styleOptions,
      classes: { base: `${classes.root} ${classes.focus}` },
    });
  }

  function handleBlur() {
    setStyleOptions({
      ...styleOptions,
      classes: { base: classes.root },
    });
  }

  return (
    <Element
      options={{ ...getStyleOptions(), ...options }}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChange={onChange}
    />
  );
}

StripeElement.propTypes = Props;
StripeElement.defaultProps = DefaultProps;
